<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <div class="right-info">
      СН РК 5.01-12-2003<br />
      Приложение 4<br />
      Рекомендуемое
    </div>
    <div class="chapter-title">Журнал забивки свай</div>
    <n-items v-if="project">
      <n-input title="1. Наименование строительной организации" v-bind="$form.input('executor')" :text="!editable" />
      <n-input title="2. Место расположения площадки" v-bind="$form.input('address')" :text="!editable" />
      <n-input title="3. Дата начала работ" v-bind="$form.input('startedAt')" :text="!editable" />
      <n-input title="4. Дата окончания работ " v-bind="$form.input('endedAt')" :text="!editable" />
      <n-input title="5. Тип молота" v-bind="$form.input('hammerType')" :text="!editable" />
      <n-input title="6. Вес ударной части молота, кН" v-bind="$form.input('hammerWeight')" :text="!editable" />
      <n-input title="7. Тип копра" v-bind="$form.input('corpType')" :text="!editable" />
      <n-input title="8. Марка свай" v-bind="$form.input('pileMark')" :text="!editable" />
      <n-input title="9. Продолжительность технического обслуживания молота, мин." v-bind="$form.input('techDuration')" :text="!editable" />
      <n-input title="10. Фактическая прочность бетона свай, МПа" v-bind="$form.input('concreteStrength')" :text="!editable" />
      <n-input title="11. Сведения о дефектах сваи при забивке" v-bind="$form.input('problem')" :text="!editable" />
      <n-input title="Ф.И.О., должность исполнителя работ" v-bind="$form.input('worker')" :text="!editable" />
      <n-input title="Ф.И.О., должность представителя строительной лаборатории" v-bind="$form.input('buildLab')" :text="!editable" />
      <n-button v-if="editable" color="success" @click="submit">Сохранить</n-button>
    </n-items>
  </div>
</template>

<script>
export default {
  name: 'MainChapter1',
  props: {
    project: { type: Object, default: () => ({}), },
    journal: { type: Object, default: () => ({}), },
    editable: { type: Boolean, default: false, },
  },
  data: () => ({
  }),
  created() {
    this.$form.init(this.journal.data)
  },
  methods: {
    submit() {
      this.$var('load', true)
      $api.journals.edit(this.project.id, this.journal.name, this.$form.get()).then(() => {
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
  
  }
</style>
